import { Component, effect, inject, OnInit } from '@angular/core';
import { DacScenarioService } from './dac-scenarios.service';
import { getDacScenariosDataTableStructure } from './utils/dac-scenarios-data-table-object';
import { DataTableRowActions, DynamicDataTable } from '@/components/data-table-builder/data-table.types';
import { PageHeaderComponent } from '@/components/shared/page-header/page-header.component';
import { DataTableBuilderComponent } from '@/components/data-table-builder/data-table-builder.component';
import { Scenario } from '@/types/scenarios.types';
import { Router } from '@angular/router';
import { DacScenariosRepository } from '@/store/dac-scenarios-state/dac-scenarios-state.repository';
import { createServerQuery } from '@/components/data-table-builder/server-query';

@Component({
  selector: 'sm-dac-scenarios',
  imports: [PageHeaderComponent, DataTableBuilderComponent],
  templateUrl: './dac-scenarios.component.html',
  styleUrl: './dac-scenarios.component.scss',
})
export class DacScenariosComponent implements OnInit {
  dacScenarioService = inject(DacScenarioService);
  router = inject(Router);
  scenarioRepository = inject(DacScenariosRepository);

  breadcrumb = [
    {
      label: 'settings.dacScenarios.breadcrumb.parametres',
      routerLink: ['/settings'],
    },
    {
      label: 'settings.dacScenarios.breadcrumb.scenarios',
      routerLink: ['/settings', 'dac-scenarios'],
    },
  ];

  data: Scenario[] = [];
  loading = false;
  totalRecords = 0;

  rowActionsFn: (target: Scenario) => DataTableRowActions = (target: Scenario) => {
    return {
      inspectAction: () => {
        this.router.navigate(['/settings', 'dac-scenarios', 'inspect', this.scenarioRepository.getNested('response', 'id')]);
      },
      editAction: () => {
        this.router.navigate(['/settings', 'dac-scenarios', 'edit', this.scenarioRepository.getNested('response', 'id')]);
      },
      additionalActions: {
        activate: [
          {
            label: target.active ? 'settings.dacScenarios.table.deactivate' : 'settings.dacScenarios.table.activate',
            icon: target.active ? 'pi pi-times' : 'pi pi-check',
            action: () => this.changeActive(target.id),
          },
        ],
      },
    };
  };

  datatableObject: DynamicDataTable = getDacScenariosDataTableStructure({
    store: this.scenarioRepository,
    rowActionsFn: this.rowActionsFn,
    enableServerActions: true,
    createAction: () => {
      this.router.navigate(['/settings', 'dac-scenarios', 'add']);
    },
  });

  serverQuery = createServerQuery({});

  constructor() {
    effect(() => {
      const page = this.serverQuery.page();
      const size = this.serverQuery.pageSize();
      const sortBy = this.serverQuery.sortBy();
      const sortOrder = this.serverQuery.sortOrder();
      const search = this.serverQuery.search();
      const sort = sortBy ? `${sortBy},${sortOrder}` : 'updatedAt,desc';
      this.loadData(page, size, sort, search);
    });
  }

  ngOnInit() {
    this.datatableObject = getDacScenariosDataTableStructure({
      store: this.scenarioRepository,
      rowActionsFn: this.rowActionsFn,
      enableServerActions: true,
      serverQuery: this.serverQuery,
      createAction: () => {
        this.router.navigate(['/settings', 'dac-scenarios', 'add']);
      },
    });
    this.loadData();
  }

  loadData(page = 0, size = 10, sort = 'updatedAt,desc', search = '') {
    this.dacScenarioService
      .getAll({
        page,
        size,
        sort,
        search,
      })
      .subscribe({
        next: data => {
          this.data = data.content;
          this.totalRecords = data.totalElements;
          this.loading = false;
        },
      });
  }

  changeActive(id: number) {
    this.dacScenarioService.changeActive(id).subscribe({
      next: () => {
        this.loadData();
      },
    });
  }
}
